/**
 * Centralized query keys for Connections feature
 * All files in this feature should import and use these constants
 * instead of hardcoding query key strings.
 */

export const ORGANIZATION_CONNECTIONS_LIST_QUERY_KEY = 'organization-connections-list';
export const CONNECTION_QUERY_KEY = 'connection';
export const CONNECTION_NOTES_QUERY_KEY = 'connection-notes';
export const CONNECTION_STATUS_HISTORY_QUERY_KEY = 'connection-status-history';
export const CONNECTION_CHANGE_HISTORY_QUERY_KEY = 'connection-change-history';
export const CONNECTION_EVENT_HISTORY_QUERY_KEY = 'connection-event-history';
